/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: a8dfe05f561d
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  UploadPresetDetail,
  UploadPresetDetail$zodSchema,
} from "./uploadpresetdetail.js";

export type GetUploadPresetGlobals = { cloud_name?: string | undefined };

export const GetUploadPresetGlobals$zodSchema: z.ZodType<
  GetUploadPresetGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type GetUploadPresetRequest = { name: string };

export const GetUploadPresetRequest$zodSchema: z.ZodType<
  GetUploadPresetRequest
> = z.object({
  name: z.string().describe("The name of the upload preset."),
});

export type GetUploadPresetResponse = UploadPresetDetail | ApiError;

export const GetUploadPresetResponse$zodSchema: z.ZodType<
  GetUploadPresetResponse
> = z.union([
  UploadPresetDetail$zodSchema,
  ApiError$zodSchema,
]);
